import { REQUEST_HEADER_STANDALONE_TOKEN } from '@agroone/entities'
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { API_URL } from '../models'
import { StandaloneTokenService } from '../services/standalone-token.service'

@Injectable()
export class StandaloneTokenInterceptor implements HttpInterceptor {
  private standaloneTokenService = inject(StandaloneTokenService)

  private _apiUrl: string = inject(API_URL)

  /**
   * Intercept the request and add the shared token to the headers
   */
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const standaloneToken: string | null = this.standaloneTokenService.getCurrentToken()

    if (standaloneToken && this.isApiRequest(request.url)) {
      const modifiedRequest: HttpRequest<unknown> = request.clone({
        setHeaders: {
          [REQUEST_HEADER_STANDALONE_TOKEN]: standaloneToken,
        },
      })

      return next.handle(modifiedRequest)
    }

    return next.handle(request)
  }

  /**
   * Check if the request is to the API
   */
  private isApiRequest(url: string): boolean {
    return url.includes(this._apiUrl)
  }
}
